import { render } from "./MyResume.vue?vue&type=template&id=27967f74&scoped=true"
import script from "./MyResume.vue?vue&type=script&lang=js"
export * from "./MyResume.vue?vue&type=script&lang=js"

import "./MyResume.vue?vue&type=style&index=0&id=27967f74&scoped=true&lang=css"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27967f74"]])

export default __exports__